import { render, staticRenderFns } from "./envios.vue?vue&type=template&id=6b7e0695"
import script from "./envios.vue?vue&type=script&lang=ts"
export * from "./envios.vue?vue&type=script&lang=ts"
import style0 from "./envios.vue?vue&type=style&index=0&id=6b7e0695&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports